import React, { Component } from 'react';
import { Link, Redirect } from "react-router-dom";
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { GenericSimpleButton, GenericModal, GenericModalButton, MessagePopup } from 'com-gyf-webcore-userinterfacecomponents';
import 'rc-dialog/assets/bootstrap.css';


class Footer extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            
        };
        this.validateCuenta = this.validateCuenta.bind(this);
    }

    validateCuenta() {
        this.props.validate(this.props.data);
    }

    routeToNuevaSolicitudTipoEmpresa() {
        $('#AnteriorCuenta').modal('toggle');
    }

    routeToVistaCliente() {
        $('#CancelCuenta').modal('toggle');
    }

    render() {
        const { tarjetas, screen, routeToBack, routeToNext, validate, data, guardarBorrador, routeToNuevaSolicitudTipoEmpresa, routeToVistaCliente } = this.props;
        
        let lastButton = !this.props.tarjetas.esModificacion ? <button onClick={() => this.routeToNuevaSolicitudTipoEmpresa()} className="btn btn-secondary" data-target="#AnteriorCuenta">&#60; Anterior</button>:
        <button onClick={() => this.routeToVistaCliente()} className="btn btn-secondary" data-target="#CancelCuenta"> &#60; Anterior</button>
        
        let cancelButton = <button onClick={() => this.routeToVistaCliente()} className="btn btn-secondary" data-target="#CancelCuenta">Cancelar</button>
        
        let borradorButton = <GenericSimpleButton buttonType="button" text="Guardar borrador" buttonClass="btn btn-secondary" onClick={guardarBorrador} />
        
        let saveButton = <GenericSimpleButton buttonType="button" text="Finalizar" buttonClass="btn btn-cta" onClick={this.validateCuenta} buttonType="button" />
        
        let saveButtonDisabled = <GenericSimpleButton buttonType="button" text="Finalizar" buttonClass="btn btn-secondary" onClick={()=>{}} buttonType="button" />

        //LA FUNCIONALIDAD Y LEYENDA DEL BOTÓN FINALIZAR DEPENDE DEL TIPO DE CUENTA Y DE SI HAY O NO ADICIONALES
        if(tarjetas.tipoEmpresa.EmpresaIndividuos == "I"){
            if(Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length>0){
                saveButton = <GenericSimpleButton buttonType="button" text="Siguiente" buttonClass="btn btn-cta" onClick={this.props.redirectAdicionalesEmpresa} buttonType="button" />
            }
        }else{
            saveButton = <GenericSimpleButton buttonType="button" text="Siguiente" buttonClass="btn btn-cta" onClick={this.props.redirectAdicionalesEmpresa} buttonType="button" />
        }

        return (
            <div className="row top-separator-md">

                {(data.ERROR_CUENTA && data.ERROR_CUENTA["TarjetaTipoId"]) &&
                    <MessagePopup isHidden={data.ERROR_CUENTA["TarjetaTipoId"]}
                        message={"El tipo de tarjeta asociada al tipo de cuenta no está vigente en ATLAS"}
                        classMessage={"error"} />
                }

                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            {lastButton}
                            <div style={{ marginLeft: "29px", display: "inline-block" }}>
                                {cancelButton}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{ float: "right" }}>

                                {/* TODO: se comenta componente del Boton 'Guardar Borrador' por que no está desarrollado por completo
                                borradorButton
                                */}

                                <div style={{ marginLeft: "29px", display: "inline-block" }}>
                                    {!this.props.hideAceptar ? saveButton : saveButtonDisabled}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;